import React from 'react';

export const QuickResourcesUTSGStudent = [
  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and student well-being.'
  },
  {
    title: 'Health & Wellness Centre',
    phone: '416 978 8030',
    hours: 'Business Hours',
    location: '214 College St., 2nd Floor',
    website: 'www.studentlife.utoronto.ca/hwc',
    description:
      'Confidential mental health and physical health services provided by an interdisciplinary ' +
      'team of health professionals'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: 'Gerstein Science Information Centre (Gerstein Library), Suite B139',
    website: 'www.thesvpcentre.utoronto.ca',
    description:
      'The Centre facilitates access to support, services and accommodations for students, staff and ' +
      'faculty members who have experienced sexual violence or sexual harassment.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, Suites 416-417',
    website: 'sgdo.utoronto.ca',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'First Nations House (Indigenous Student Services)',
    phone: ['416 978 8227', '1 800 810 8069'],
    hours: 'Business Hours',
    location: '563 Spadina Avenue, 3rd Floor',
    website: 'https://studentlife.utoronto.ca/department/first-nations-house/',
    description:
      'First Nations House provides culturally relevant services to Indigenous students in support ' +
      'of academic success, personal growth and leadership development.'
  },
  {
    title: 'Centre for International Experiences',
    phone: '416 978 2564',
    hours: 'Business Hours',
    location: '33 St. George Street',
    website: 'www.studentlife.utoronto.ca/cie',
    description:
      'A diverse community of international students coming to U of T and domestic students ' +
      'looking to go abroad.'
  },
  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Responds to students, staff, and faculty members of the University of Toronto community ' +
      'who have personal safety concerns.'
  },
  {
    title: 'Multi-Faith Centre',
    phone: '416 946 3120',
    hours: 'Business Hours',
    location: '569 Spadina Avenue',
    website: 'www.studentlife.utoronto.ca/mf',
    description:
      'Supports the spiritual well-being of students, staff and faculty and to increases our ' +
      'understanding of and respect for religious beliefs and practices.'
  },
  {
    title: 'Distress Centres of Greater Toronto',
    phone: '416 408 4357',
    hours: '24/7',
    location: 'Various, Canada',
    website: 'www.torontodistresscentre.com/',
    description:
      'Provides crisis, emotional support and suicide prevention + intervention + postvention ' +
      'services to individuals in our community.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1-844-451-9700">1-844-451-9700</a>
        <br />
        Outside of North America: <br /><a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://mentalhealth.utoronto.ca/telus-health-student-support/',
    description:
      'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  }
];

export const QuickResourcesUTSGStaff = [
  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and student well-being.'
  },
  {
    title: 'Health & Wellness Centre',
    phone: '416 978 8030',
    hours: 'Business Hours',
    location: '214 College St., 2nd Floor',
    website: 'https://studentlife.utoronto.ca/department/health-wellness/',
    description:
      'Confidential mental health and physical health services provided by an interdisciplinary ' +
      'team of health professionals'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: 'Gerstein Science Information Centre (Gerstein Library), Suite B139',
    website: 'www.thesvpcentre.utoronto.ca',
    description:
      'The Centre facilitates access to support, services and accommodations for students, staff and ' +
      'faculty members who have experienced sexual violence or sexual harassment.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, Suites 416-417',
    website: 'sgdo.utoronto.ca',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'First Nations House (Indigenous Student Services)',
    phone: ['416 978 8227', '1 800 810 8069'],
    hours: 'Business Hours',
    location: '563 Spadina Avenue, 3rd Floor',
    website: 'https://studentlife.utoronto.ca/department/first-nations-house/',
    description:
      'First Nations House provides culturally relevant services to Indigenous students in support ' +
      'of academic success, personal growth and leadership development.'
  },
  {
    title: 'Centre for International Experiences',
    phone: '416 978 2564',
    hours: 'Business Hours',
    location: '33 St. George Street',
    website: 'https://studentlife.utoronto.ca/department/centre-for-international-experience/',
    description:
      'A diverse community of international students coming to U of T and domestic students ' +
      'looking to go abroad.'
  },
  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Responds to students, staff, and faculty members of the University of Toronto community ' +
      'who have personal safety concerns.'
  },
  {
    title: 'Multi-Faith Centre',
    phone: '416 946 3120',
    hours: 'Business Hours',
    location: '569 Spadina Avenue',
    website: 'https://studentlife.utoronto.ca/department/multi-faith-centre-for-spiritual-study-practice/',
    description:
      'Supports the spiritual well-being of students, staff and faculty and to increases our ' +
      'understanding of and respect for religious beliefs and practices.'
  },
  {
    title: 'Distress Centres of Greater Ontario',
    phone: '416 408 4357',
    hours: '24/7',
    location: '',
    website: 'www.torontodistresscentre.com/',
    description:
      'Provides crisis, emotional support and suicide prevention + intervention + postvention ' +
      'services to individuals in our community.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1-844-451-9700">1-844-451-9700</a>
        <br />
        Outside of North America: <br /><a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://mentalhealth.utoronto.ca/telus-health-student-support/',
    description:
      'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  }
];

export const QuickResourcesUTSCStaff = [
  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and student well-being.'
  },
  {
    title: 'Health & Wellness Centre',
    phone: '416 287 7065',
    hours: 'Business Hours',
    location: 'SL-270, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/hwc',
    description:
      'Offers convenient and confidential health care, counselling and health promotion services for all registered students at UTSC.'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: '702 Spadina Avenue',
    website: 'www.thesvpcentre.utoronto.ca',
    description:
      'The Centre facilitates access to support, services and accommodations for students, staff and ' +
      'faculty members who have experienced sexual violence or sexual harassment.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, Suites 416-417',
    website: 'sgdo.utoronto.ca',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'First Nations House (Indigenous Student Services)',
    phone: ['416 978 8227', '1 800 810 8069'],
    hours: 'Business Hours',
    location: '563 Spadina Avenue, 3rd Floor',
    website: 'https://studentlife.utoronto.ca/department/first-nations-house/',
    description:
      'First Nations House provides culturally relevant services to Indigenous students in support ' +
      'of academic success, personal growth and leadership development.'
  },
  {
    title: 'International Student Centre',
    phone: '416 287 7518',
    hours: 'Business Hours',
    location: 'IC 350, 1095 Military Trail',
    website: 'www.uoft.me/utscinternational',
    description:
      'Provides International students with support and guidance including the University Health Insurance Plan.'
  },
  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Responds to students, staff, and faculty members of the University of Toronto community ' +
      'who have personal safety concerns.'
  },
  {
    title: 'Multi-Faith Engagement',
    phone: '',
    phoneNode: (
      <span style={{ wordBreak: "break-all" }}>
        <a href="mailto:cep@utsc.utoronto.ca">cep@utsc.utoronto.ca</a> 
        <br/>
      </span>
    ),
    hours: 'Business Hours',
    location: '',
    website: 'www.utsc.utoronto.ca/studentlife/multi-faith-engagement',
    description:
      'Services and programs to foster practice, observance, interfaith community, support and learning to students.'
  },
  {
    title: 'Distress Centres of Greater Ontario',
    phone: '416 408 4357',
    hours: '24/7',
    location: 'Various, Canada',
    website: 'www.torontodistresscentre.com/',
    description:
      'Provides crisis, emotional support and suicide prevention + intervention + postvention ' +
      'services to individuals in our community.'
  },
  {
    title: 'UTSC Student Experience app (UTSC)',
    phone: '',
    hours: '',
    location:
      'Search "UTSC Student Experience" on the App Store or Google Play',
    website: 'uoft.me/utscapp',
    description:
      'A convenient way to access student services on the go and connect with campus events.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1-844-451-9700">1-844-451-9700</a>
        <br />
        Outside of North America: <br /><a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://mentalhealth.utoronto.ca/telus-health-student-support/',
    description:
      'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  }
];

export const QuickResourcesUTSCStudent = [
  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and student well-being.'
  },
  {
    title: 'Health & Wellness Centre',
    phone: '416 287 7065',
    hours: 'Business Hours',
    location: 'SL-270, 1265 Military Trail',
    website: 'www.utsc.utoronto.ca/hwc',
    description:
      'Offers convenient and confidential health care, counselling and health promotion services for all registered students at UTSC.'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: '702 Spadina Avenue',
    website: 'www.thesvpcentre.utoronto.ca',
    description:
      'The Centre facilitates access to support, services and accommodations for students, staff and ' +
      'faculty members who have experienced sexual violence or sexual harassment.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, Suites 416-417',
    website: 'sgdo.utoronto.ca',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'First Nations House (Indigenous Student Services)',
    phone: ['416 978 8227', '1 800 810 8069'],
    hours: 'Business Hours',
    location: '563 Spadina Avenue, 3rd Floor',
    website: 'https://studentlife.utoronto.ca/department/first-nations-house/',
    description:
      'First Nations House provides culturally relevant services to Indigenous students in support ' +
      'of academic success, personal growth and leadership development.'
  },
  {
    title: 'International Student Centre',
    phone: '416 287 7518',
    hours: 'Business Hours',
    location: 'IC 350, 1095 Military Trail',
    website: 'www.uoft.me/utscinternational',
    description:
      'Provides International students with support and guidance including the University Health Insurance Plan.'
  },
  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Responds to students, staff, and faculty members of the University of Toronto community ' +
      'who have personal safety concerns.'
  },
  {
    title: 'Multi-Faith Engagement',
    phone: '',
    phoneNode: (
      <span style={{ wordBreak: "break-all" }}>
        <a href="mailto:cep@utsc.utoronto.ca">cep@utsc.utoronto.ca</a> 
        <br/>
      </span>
    ),
    hours: 'Business Hours',
    location: '',
    website: 'www.utsc.utoronto.ca/studentlife/multi-faith-engagement',
    description:
      'Services and programs to foster practice, observance, interfaith community, support and learning to students.'
  },
  {
    title: 'Distress Centres of Greater Ontario',
    phone: '416 408 4357',
    hours: '24/7',
    location: 'Various, Canada',
    website: 'www.torontodistresscentre.com/',
    description:
      'Provides crisis, emotional support and suicide prevention + intervention + postvention ' +
      'services to individuals in our community.'
  },
  {
    title: 'UTSC Student Experience app (UTSC)',
    phone: '',
    hours: '',
    location:
      'Search "UTSC Student Experience" on the App Store or Google Play',
    website: 'uoft.me/utscapp',
    description:
      'A convenient way to access student services on the go and connect with campus events.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1-844-451-9700">1-844-451-9700</a>
        <br />
        Outside of North America: <br /><a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://mentalhealth.utoronto.ca/telus-health-student-support/',
    description:
      'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  }
];

export const QuickResourcesUTMStudent = [
  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and student well-being.'
  },
  {
    title: 'Health & Counselling Centre',
    phone: '905 828 5255',
    hours: 'Business Hours',
    location: 'DV 1152',
    website: 'www.utm.utoronto.ca/health',
    description:
      'HCC provides medical services, physical and mental health services and peer to peer health education through an interdisciplinary team of health professionals. The HCC also has a dedicated student wellness space, the Wellness Den, that features daily, drop-in wellness activities to support learning and success. Drop by the Student Services Hub (DV 2207) to build your wellness routine'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: 'DV 3094G',
    website: 'www.svpscentre.utoronto.ca ',
    description:
      'Provide confidential services for students, staff, and faculty affected by sexual violence and/or sexual harassment and also provides programming, training, education and consultation.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 4th Floor',
    website: 'sgdo.utoronto.ca',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'Indigenous Centre',
    phone: '905 569 4867',
    hours: 'Business Hours',
    location: 'DV 3206',
    website: 'www.utm.utoronto.ca/indigenous-centre',
    description:
      'TThe Centre supports Indigenous students, staff, and faculty and also offers opportunities for non-Indigenous peoples to better understand Indigenous peoples, cultures, stories, and ceremonies through programs.'
  },
  {
    title: 'International Education Centre',
    phone: '905 569 4716',
    hours: 'Business Hours',
    location: 'Student Services Hub, Davis Building',
    website: 'www.utm.utoronto.ca/international',
    description: 'IEC offers international opportunities for academic credit and as co-curricular experiences. IEC also assists international students on immigration-related matters, UHIP and transition to University while offering programs to connect.'
  },
  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Responds to students, staff, and faculty members of the University of Toronto community ' +
      'who have personal safety concerns.'
  },
  {
    title: 'Multi-Faith Centre',
    phone: '',
    hours: '',
    location: '',
    website: 'www.utm.utoronto.ca/utm-engage/student-groups/multi-faith ',
    description:
      'Provides opportunities to celebrate your spiritual and faith-based practices on campus by providing multi-faith spaces on campus and faith-based campus groups.'
  },
  {
    title: 'Distress Centres of Greater Ontario',
    phone: '416 408 4357',
    hours: '24/7',
    location: '',
    website: 'www.torontodistresscentre.com/',
    description:
      'Offer anonymous and confidential distress and emotional support lines in 8 languages. Interpreters for callers in crisis are available in 151 languages. TTY service available for the hearing impaired.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1-844-451-9700">1-844-451-9700</a>
        <br />
        Outside of North America: <br /><a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://mentalhealth.utoronto.ca/telus-health-student-support/',
    description:
      'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  }
];

export const QuickResourcesUTMStaff = [
  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and student well-being.'
  },
  {
    title: 'Health & Counselling Centre',
    phone: '905 828 5255',
    hours: 'Business Hours',
    location: 'DV 1152',
    website: 'www.utm.utoronto.ca/health',
    description:
      'HCC provides medical services, physical and mental health services and peer to peer health education through an interdisciplinary team of health professionals. The HCC also has a dedicated student wellness space, the Wellness Den, that features daily, drop-in wellness activities to support learning and success. Drop by the Student Services Hub (DV 2207) to build your wellness routine'
  },
  {
    title: 'Sexual Violence Prevention & Support Centre',
    phone: '416 978 2266',
    hours: 'Business Hours',
    location: 'DV 3094G',
    website: 'www.svpcentre.utoronto.ca',
    description:
      'Provide confidential services for students, staff, and faculty affected by sexual violence and/or sexual harassment and also provides programming, training, education and consultation.'
  },
  {
    title: 'Sexual & Gender Diversity Office',
    phone: '416 946 5624',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 4th Floor',
    website: 'sgdo.utoronto.ca',
    description:
      'Develops partnerships to build supportive learning and working communities at the University ' +
      'of Toronto by working towards equity and challenging discrimination.'
  },
  {
    title: 'Indigenous Centre',
    phone: '905 569 4867',
    hours: 'Business Hours',
    location: 'DV 3206',
    website: 'www.utm.utoronto.ca/indigenous-centre',
    description:
      'The Centre supports Indigenous students, staff, and faculty and also offers opportunities for non-Indigenous peoples to better understand Indigenous peoples, cultures, stories, and ceremonies through programs.'
  },
  {
    title: 'International Education Centre',
    phone: '905 569 4716',
    hours: 'Business Hours',
    location: 'Student Services Hub, Davis Building',
    website: 'www.utm.utoronto.ca/international',
    description: 'IEC offers international opportunities for academic credit and as co-curricular experiences. IEC also assists international students on immigration-related matters, UHIP and transition to University while offering programs to connect.'
  },
  {
    title: 'Community Safety Office',
    phone: '416 978 1485',
    hours: 'Business Hours',
    location: '21 Sussex Avenue, 2nd Floor',
    website: 'www.communitysafety.utoronto.ca',
    description:
      'Responds to students, staff, and faculty members of the University of Toronto community ' +
      'who have personal safety concerns.'
  },
  {
    title: 'Multi-Faith Centre',
    phone: '',
    hours: '',
    location: '',
    website: 'www.utm.utoronto.ca/utm-engage/student-groups/multi-faith',
    description:
      'Provides opportunities to celebrate your spiritual and faith-based practices on campus by providing multi-faith spaces on campus and faith-based campus groups.'
  },
  {
    title: 'Distress Centres of Greater Ontario',
    phone: '416 408 4357',
    hours: '24/7',
    location: '',
    website: 'www.torontodistresscentre.com/',
    description:
      'Provides crisis, emotional support and suicide prevention + intervention + postvention ' +
      'services to individuals in our community.'
  },
  {
    title: 'U of T Telus Health Student Support',
    phoneNode: (
      <span>
        <a href="tel:1-844-451-9700">1-844-451-9700</a>
        <br />
        Outside of North America: <br /><a href="tel:001-416-380-6578">001-416-380-6578</a>
        <br />
      </span>
    ),
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'https://mentalhealth.utoronto.ca/telus-health-student-support/',
    description:
      'Real-time and/or appointment-based, multi-lingual, confidential, 24-hour support for any school, health, or general life concern at no cost to students.'
  }
];

export const QuickResourcesOther = [
  {
    title: 'Good2Talk Student Helpline',
    phone: '1 866 925 5454',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'good2talk.ca',
    description:
      'Professional counselling, information and referrals helpline for mental health, addictions and student well-being.'
  },   {
    title: 'Sexual Assault & Domestic Violence Care Centres',
    phone: '',
    hours: '24/7',
    location: '',
    website: '',
    descriptionNode:
      (<div style={{wordBreak: 'break-word'}}>
        Scarborough Hospital Network's Emergency Departments{' '}
        <a href='https://www.shn.ca/sexual-assault/' target="_blank" rel="noopener noreferrer">
        https://www.shn.ca/sexual-assault/
        </a>
        <br/>
        Women's College Hospital, Mobile Locations 24/7 and Partner ED Locations{' '}
        <a href='www.womenscollegehospital.ca/care-programs/sexual-assault-domestic-violence-care-centre/' target="_blank" rel="noopener noreferrer">
          https://www.womenscollegehospital.ca/care-programs/sexual-assault-domestic-violence-care-centre/
        </a>
      </div>)
  }, {
    title: 'Toronto Rape Crisis Centre / Multicultural Women Against Rape',
    phone: '416 597 8808',
    hours: '24/7',
    location: '',
    website: 'trccmwar.ca',
    description:
      'A grassroots, women and non-binary run collective working towards a violence-free world by providing anti-oppressive, feminist peer support to survivors of sexual violence through support, education and activism.'
  }, {
    title: 'Connex Ontario',
    phone: '',
    hours: '24/7',
    location: 'Various, Ontario',
    website: 'www.connexontario.ca/',
    description:
      'Provides confidential and free information about health services information for people experiencing problems with alcohol and drugs, mental illness and/or gambling.'
  }, {
    title: 'Anishnawbe Health Toronto Mental Health Crisis Line',
    phone: ['416 360 0486', '416 920 2605'],
    hours: 'Business Hours',
    location: '225 Queen St E or 179 Gerrard, St E',
    website: 'www.aht.ca',
    description:
      'Improves health & well-being with Anishnawbe Health Toronto traditional healers, Elders and medicine people, ' +
      'and other health professionals.'
  }, {
    title: "Assaulted Women's Helpline",
    phone: '416 863 0511',
    hours: '24/7',
    location: '',
    website: 'www.awhl.org/home',
    description:
      'Offers a 24-hour telephone and TTY crisis line to all woman who have experienced abuse.'
  }, {
    title: 'Distress Centres of Greater Toronto',
    phone: '416 408 4357',
    hours: '24/7',
    location: '',
    website: 'www.torontodistresscentre.com',
    description:
      'Provides crisis, emotional support and suicide prevention + intervention + postvention services to individuals in our community via hotline, online chat, and text and some in-person individual and group support.'
  }, {
    title: 'LGBT Youth Line',
    phone: ['1 800 268 9688', '647 694 4275'],
    hours: '24/7',
    location: '',
    website: 'www.youthline.ca',
    description:
      'Confidential, non-judgmental & informed LGBTTQQ2SI peer support that affirms and supports the experiences of youth (29 and under) across Ontario via chat, text and email.'
  }, {
    title: 'Gerstein Centre Mental Health Crisis Line',
    phone: '416-929-5200; TTY 416-929-9647',
    hours: '24/7',
    location: '',
    website: 'gersteincentre.org/',
    description:
      'Provides mental health crisis support, strategies for addressing immediate problems, and connections to ' +
      'services offering ongoing support.'
  }, {
    title: 'Scarborough Health Network Community Crisis Program',
    phone: '416 495 2891',
    hours: '24/7',
    location: 'Various, Scarborough & East York',
    website: 'www.shn.ca/mental-health/crisis-support/',
    description:
      'Providing telephone crisis support, crisis de-escalation and support, safety and crisis planning, mental health assessment and referral, brief psychotherapies, and community visits.'
  }, {
    title: 'Distress and Crisis Ontario',
    phone: '',
    hours: '',
    location: '',
    website: 'http://www.dcontario.org/',
    description:
      'Offer support and a variety of services where you can find a listening ear for lonely, depressed, and/or suicidal people, usually 24/7.'
  }, {
    title: 'Kids Help Phone',
    phone: '1 800 668 6868',
    hours: '',
    location: '',
    website: 'kidshelpphone.ca/',
    description:
      '24/7, national support service. We offer professional counselling, information and referrals and volunteer-led, text-based support to young people in both English and French.'
  }, {
    title: 'Canadian Mental Health Association',
    phone: '',
    hours: '',
    location: '',
    website: 'ontario.cmha.ca/',
    description:
      'Promote mental health in collaboration with others and further equitable access to mental health services and champion the reduction of mental health disparities.'
  }, {
    title: 'Big White Wall',
    phone: '',
    hours: '',
    location: '',
    website: 'www.bigwhitewall.com/?lang=en-ca&from=ca/v2/Home.aspx?lang=en-ca',
    description:
      'Online peer support community for mental health, free for Ontario students. Can be accessed 24/7 from anywhere with trained practitioners available.'
  }, {
    title: 'BounceBack',
    phone: '',
    hours: '',
    location: '',
    website: 'bouncebackontario.ca/',
    description:
      'Free skill-building program managed by CMHA where they offer coaching programs through phone sessions and online videos with tips.'
  }, {
    title: 'Wellness Together Canada',
    phone: '',
    hours: '',
    location: '',
    website: 'ca.portal.gs/',
    description:
      'Provides free online resources, tools, apps and connections to trained volunteers and qualified mental health professionals when needed.'
  },
];

export default { QuickResourcesUTSGStudent };



// WEBPACK FOOTER //
// ./src/containers/IARReference/Resources/QuickResources.js